import { Contact, EventApplication, JobApplication, MultiLangText } from '.';

export enum AppUserStatus {
	active = 'active',
	suspended = 'suspended',
	deleting = 'deleting', // used for safe guard, e.g. user won't get duplicated email
}

export interface AppUserProfile {
	id: string;
	chineseName: string;
	firstName: string;
	lastName: string;
	email?: string;
	contactEmail?: string;
	mobileNumber?: string;
	status: AppUserStatus;
	redFlag: boolean;
	userCode: string;
}

export interface CreateAppUserDto {
	chineseName?: string;
	firstName?: string;
	lastName?: string;
	email?: string;
	contactEmail?: string;
	mobileNumber?: string;
	contactId?: number;
}

export enum AttendanceImportMatchType {
	single = 'single',
	none = 'none',
	multiple = 'multiple',
}

export type AttendanceImportApplication = Pick<
	JobApplication | EventApplication,
	'chineseName' | 'firstName' | 'lastName' | 'email' | 'mobileNumber'
>;

export function isKeyOfAttendanceImportApplication(
	x: string,
): x is keyof AttendanceImportApplication {
	return [
		'chineseName',
		'firstName',
		'lastName',
		'email',
		'mobileNumber',
	].includes(x);
}

export interface AttendanceImportTableItem {
	index: number;
	application: AttendanceImportApplication;
	imported: boolean;
	matchType?: AttendanceImportMatchType;
	isNewContact?: boolean;
	sameNewContactIndex?: number; // index of the first item with same new contact
	appUserIdCreated?: string; // HACK: to store newly created appUserId, the flow did bulk-search in upload dialog, cannot use the same workflow
	profileCode?: string;
	matchedContacts?: Contact[];
	isSelectable?: boolean;
	contactId?: number;
}

export enum SocialCvItemType {
	job = 'job',
	event = 'event',
	info = 'info',
}

export interface SocialCv {
	id: string;
	userId: string;
	itemType: SocialCvItemType;
	startDate: Date;
	endDate?: Date;
	itemId: string;
	title: MultiLangText;
	ngoId?: number;
	ngoName?: MultiLangText;
	serviceHours?: number;
	createdAt?: Date;
	updatedAt?: Date;
}

export interface QrCodeData {
	contactQrCode?: string;
	userQrCode?: string;
}
